export const API_SERVICE_KEY = Symbol()
export const STORE_KEY = Symbol()
export const PATH_KEY = Symbol()
export const APP_ENV_KEY = Symbol()
export const CLIPBOARD_SERVICE_KEY = Symbol()

export * from "@layout/di/keys"
export * from "@survey/di/keys"
